import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  button: {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  heading: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: 20,
    lineHeight: '28px',
    color: '#666666',
  },
  secondaryHeading: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 12,
    lineHeight: '18px',
    color: '#CCCCCC',
    marginTop: 6,
    marginRight: 46,
    right: 0,
    position: 'absolute',
  },
  description: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '22px 48px',
    position: 'static',
    width: '80%',
    left: '61px',
    top: '70px',
    background: '#FAFAFA',
    borderRadius: '2px',
    flex: 'none',
    order: 1,
    flexGrow: 0,
    margin: '0px auto',
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#666666',
  },
  container: {
    margin: '32px auto',
    width: '80%',
  },
  formLabel: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '20px',
    color: '#666666',
  },
  gridMargin: {
    margin: '15px !important',
  },
  asterisk: {
    color: '#DF0C36',
  },
  businessUnit: {
    height: 40,
    paddingRight: 0,
    width: 250,
  },
  input: {
    height: 40,
    paddingRight: 0,
    width: 153,
  },
  cargoInput: {
    height: 40,
    paddingRight: 0,
    width: 250,
  },
  inputStyle: {
    '&::placeholder': {
      color: 'gray',
      fontFamily: 'Arial',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: 14,
      lineHeight: '27px',
    },
  },
  datePicker: {
    width: 170,
    marginTop: 0,
  },
  formControl: {
    width: 160,
  },
  formControlTicketStatus: {
    width: 250,
  },
  select: {
    minWidth: 160,
    height: 40,
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
    lineHeight: '27px',
    color: '#403e3e',
  },
  dropdownStyle: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
    lineHeight: '27px',
    color: '#403e3e',
  },
  ticketDetail: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
    lineHeight: '16px',
    color: '#666666',
    textTransform: 'capitalize',
  },
  expandIcon: {
    color: '#DF0C36',
  },
  accordion: {
    margin: '0px !important',
    borderTop: '2px solid #DF0C36',
  },
  formHelperText: {
    color: '#f44336',
  },
  datePickerInput: {
    height: 40,
    paddingRight: 0,
    width: 165,
  },
}));
